import axiosInstance from './axiosInstance';

const BASE = '/coding-tracker';

// ─── Assignments ──────────────────────────────────────────────────────────────
export const getAssignments = (batchId) =>
  axiosInstance.get(`${BASE}/batches/${batchId}/assignments`);

export const getAssignmentById = (assignmentId) =>
  axiosInstance.get(`${BASE}/assignments/${assignmentId}`);

export const createAssignment = (batchId, data) =>
  axiosInstance.post(`${BASE}/batches/${batchId}/assignments`, data);
// body: { title, description?, dueDate? }

export const updateAssignment = (batchId, assignmentId, data) =>
  axiosInstance.put(`${BASE}/batches/${batchId}/assignments/${assignmentId}`, data);

export const deleteAssignment = (batchId, assignmentId) =>
  axiosInstance.delete(`${BASE}/batches/${batchId}/assignments/${assignmentId}`);

// ─── Problems ─────────────────────────────────────────────────────────────────
export const getProblems = (assignmentId) =>
  axiosInstance.get(`${BASE}/assignments/${assignmentId}/problems`);

export const addProblems = (assignmentId, problems) =>
  axiosInstance.post(`${BASE}/assignments/${assignmentId}/problems`, { problems });
// body: { problems: [{ title, slug?, link, difficulty? }] }

export const addProblemsBulk = (assignmentId, links) =>
  axiosInstance.post(`${BASE}/assignments/${assignmentId}/problems/bulk`, { links });
// body: { links: ['https://leetcode.com/problems/two-sum/', ...] }

export const deleteProblem = (assignmentId, problemId) =>
  axiosInstance.delete(`${BASE}/assignments/${assignmentId}/problems/${problemId}`);

// ─── Progress ─────────────────────────────────────────────────────────────────
export const getAssignmentProgress = (assignmentId) =>
  axiosInstance.get(`${BASE}/assignments/${assignmentId}/progress`);

// Legacy aliases (used by existing pages)
export const fetchAssignments  = getAssignments;
export const fetchAssignment   = getAssignmentById;
export const fetchProblems     = getProblems;
export const bulkAddProblems   = addProblemsBulk;
